import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

let _ = t => t,
    _t;

import styled from 'styled-components';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UIImage from 'UIComponents/image/UIImage';
import UIBox from 'UIComponents/layout/UIBox';
import UIFlex from 'UIComponents/layout/UIFlex';
import { getUpgradePointImage } from 'ui-addon-upgrades/ums/getUpgradePointImage';
import { validateModalUpgradeConfig } from 'ui-addon-upgrades/ums/utils';
import breakpoint from 'pricing-pages-ui/js/constants/Breakpoints';
import SuiteStarterCard from '../../merch-card/SuiteStarterCard';
import FeatureContent from './FeatureContent';
const FlexContainer = styled(UIFlex).withConfig({
  displayName: "UpgradeConfigContent__FlexContainer",
  componentId: "sc-1alfuo-0"
})(["z-index:1;padding-top:64px;", ";"], breakpoint.tablet(_t || (_t = _`
    padding-right: 48px;
    padding-left: 48px;
  `)));
const ImageWrapper = styled.div.withConfig({
  displayName: "UpgradeConfigContent__ImageWrapper",
  componentId: "sc-1alfuo-1"
})(["text-align:center;margin:0 auto;"]);

const getImage = upgradeConfig => {
  try {
    validateModalUpgradeConfig(upgradeConfig);
  } catch (e) {
    console.error(e);
    return /*#__PURE__*/_jsx(ImageWrapper, {});
  }

  if (!upgradeConfig || upgradeConfig && upgradeConfig.visualType && !upgradeConfig.visualKey) {
    return /*#__PURE__*/_jsx(ImageWrapper, {});
  }

  if (upgradeConfig && upgradeConfig.visualType === 'image') {
    return /*#__PURE__*/_jsx(ImageWrapper, {
      children: /*#__PURE__*/_jsx(UIImage, {
        style: {
          margin: '0 auto'
        },
        src: getUpgradePointImage(upgradeConfig.visualKey)
      })
    });
  }

  return /*#__PURE__*/_jsx(ImageWrapper, {
    children: /*#__PURE__*/_jsx(UIIllustration, {
      name: upgradeConfig.visualKey,
      height: 450
    })
  });
};

const UpgradeConfigContent = ({
  upgradeConfig
}) => {
  return /*#__PURE__*/_jsxs(FlexContainer, {
    justify: "between",
    align: "center",
    children: [/*#__PURE__*/_jsxs(UIBox, {
      grow: 1,
      basis: "50%",
      className: "p-right-4",
      children: [/*#__PURE__*/_jsx(FeatureContent, {
        upgradeConfig: upgradeConfig
      }), /*#__PURE__*/_jsx(SuiteStarterCard, {})]
    }), /*#__PURE__*/_jsx(UIBox, {
      grow: 0,
      basis: "50%",
      className: "p-left-4",
      children: getImage(upgradeConfig)
    })]
  });
};

export default UpgradeConfigContent;